import PeopleOverview from './PeopleOverview'
import enhance from './PeopleOverview.enhancer'

export default enhance(PeopleOverview)

export const peopleColumns = [
  {
    width: 225, label: 'Name', field: 'fullName', format: 'name', orderField: 'fullName',
  },
  {
    width: 375, label: 'Email', field: 'email', align: 'flex-start'
  },
  {
    width: 125, label: 'Type', field: 'role', format: 'profileType',
  },
  {
    width: 125, format: 'fullDate', field: 'updatedAt', label: 'updated At', align: 'flex-end'
  },
  {
    width: 50, field: 'select', selectable: true, format: 'checkbox', hideHeader: true, align: 'flex-end'
  }
]



// WEBPACK FOOTER //
// ./src/containers/people/PeopleOverview/index.js